import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import filterIcon from '@adsk/bim360-matrix-react-assets/funnel-icon.svg';

const FilterIcon = props => {
  const {isFilterOpen, toggleFilterPanel, dataTestId} = props;
  const filterPanelButtonClass = cx('FilterIcon', {
    'FilterIcon--active': isFilterOpen
  });

  return (
    <IconButton onClick={toggleFilterPanel} className={filterPanelButtonClass} data-testid={dataTestId}>
      <SvgIcon height="12px" width="15px">
        {filterIcon}
      </SvgIcon>
    </IconButton>
  );
};

FilterIcon.displayName = 'FilterIcon';

FilterIcon.propTypes = {
  isFilterOpen: PropTypes.bool.isRequired,
  toggleFilterPanel: PropTypes.func.isRequired,
  dataTestId: PropTypes.string
};

export default FilterIcon;
